export default {"src":"/_next/static/media/2D-plan.e3ef5f8e.svg","height":30,"width":21,"blurWidth":0,"blurHeight":0};